import React from 'react';
import { Field, reduxForm } from 'redux-form/immutable';
import PropTypes from 'prop-types';
import NavbarModulo from '../../components/NavbarModulo';
import NavbarModuloLF from '../../components/NavbarModuloFage';
const valEmp = __CONFIG__.empresa;

import {
    AsyncSelectFieldIn,
    renderDayPickerB
} from "../../Utils/renderField/renderField";

function BajaForm(props) {
    const { modulo, emp, baja, datos } = props;
    let titulo = 'Baja de colaborador';
    
    let ruta = window.location.href;
    let id_emp = ruta.split('/');

    return (
        <div>
            {valEmp === 'fage' &&
                <NavbarModuloLF
                    pais = {datos.paisNombre}
                    modulo={modulo}
                    titulo={titulo}
                />
            }
            {valEmp === '' &&
                <NavbarModulo
                    pais = {datos.paisNombre}
                    modulo={modulo}
                    titulo={titulo}
                />
            }
           
            <br />
            <div className="mb-4 card card-small text-white bg-dark mb-3">
                <div className="p-0 pt-3 d-flex flex-column flex-md-row">
                    <div className="d-flex flex-column flex-1 mx-4">
                        <div className='mb-2'>
                            <div className='row mb-2'>
                                <div className='col-8'>
                                    <Field
                                        name="colaborador"
                                        placeholder="Colaborador..."
                                        className="form-control-find"
                                        component={AsyncSelectFieldIn}
                                        loadOptions={emp}
                                        msj="Colaborador"
                                    />
                                </div>
                            </div>
                            <div className='row mb-2'>
                                <div className='col-3 ml-2'>
                                    <Field
                                        name="fecha_baja"
                                        component={renderDayPickerB}
                                        msj="Fecha de baja"
                                    />
                                </div>
                            </div>
                            <div className='d-flex flex-row mt-3 ml-2'>
                                
                                <button
                                    className='btn mr-2 mb-3 btn-primary'
                                    onClick={baja}
                                >
                                    Confirmar baja
                                </button>
                                {valEmp === 'fage' &&
                                    <a
                                        href={`/#/lfg/rr_hh/${id_emp[6]}/baja/${id_emp[8]}`}
                                        className='btn btn-secondary mb-3'
                                    >
                                        Regresar
                                    </a>
                                }
                                {valEmp === '' &&
                                    <a
                                        href={`/#/rr_hh/${id_emp[5]}/baja/${id_emp[7]}`}
                                        className='btn btn-secondary mb-3'
                                    >
                                        Regresar
                                    </a>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

BajaForm.propTypes = {
    handleSubmit: PropTypes.func,
    crear: PropTypes.bool,
    lectura: PropTypes.object,
    modulo: PropTypes.object
};

export default reduxForm({
    form: 'FormBajaColaborador',
})(BajaForm);
